import React, { Component } from 'react';

export class RegistrationComplete extends Component {

    render() {
        return (
            <div>
                <h4>Registration successful</h4>
                <p>Account Activation Required</p>
                <p>There is still one more step to finalize your registration and activate your account. We have sent an activation email to the email address you provided during registration. Please follow instructions in that email to activate your Phoenix account. Thank you.</p>
            </div>
        )
	}
}
